import * as React from 'react'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  TelegramIcon,
  ViberIcon,
} from 'react-share'

import sanitizeHTML from '../../../services/sanitizeHTML'
import viewTypeBaseUrl from '../../../services/data/viewTypeBaseUrl'

// components
import SideModal from '../../ui/SideModal/SideModal'
import Icon from '../../ui/Icon/Icon'
import ArticleCard from '../../ui/ArticleCard/ArticleCard'
import {
  ShareButtons,
  ShareContainer,
  ShareBaseButton,
  ContentContainer,
  Container,
  Title,
  Subtitle,
  Schedule,
  Body,
  RelatedContainer,
  RelatedTitle,
  MallList,
  StyledLink,
  MallLogo,
  ReferenceWidth,
  AspectRatioHelper,
  StyledBanner,
  MCM_TABLE_SCROLL_CLASS,
} from './MarketingContentModal.style'

//ads
import DesktopLeaderboard from '../../ads/DesktopLeaderboard/DesktopLeaderboard'
import MobileRectangle from '../../ads/MobileRectangle/MobileRectangle'
import ResponsiveAdsContainer from '../../ads/ResponsiveAdsContainer/ResponsiveAdsContainer'

function wrapMarketingBodyTables(html) {
  if (!html) return ''
  if (typeof DOMParser === 'undefined') return html

  try {
    const doc = new DOMParser().parseFromString(
      `<div data-mcm-wrap-root>${html}</div>`,
      'text/html',
    )
    const root = doc.querySelector('[data-mcm-wrap-root]')
    if (!root) return html

    root.querySelectorAll('table').forEach(table => {
      if (table.closest(`.${MCM_TABLE_SCROLL_CLASS}`)) return
      const parent = table.parentNode
      if (!parent) return
      const wrap = doc.createElement('div')
      wrap.className = MCM_TABLE_SCROLL_CLASS
      parent.insertBefore(wrap, table)
      wrap.appendChild(table)
    })

    return root.innerHTML
  } catch {
    return html
  }
}

function MarketingContentModal(props) {
  const { show, shareUrl, onClose, loading, data, malls: propMalls } = props
  const {
    title,
    body,
    schedule,
    bannerImage,
    malls = [],
    relatedArticles = [],
  } = data || {}
  const { url: bannerImageUrl } = bannerImage || {}
  const mallList = malls.map(mall => mall.name)

  const participatingMalls = mallList.slice(0, 3).join(', ')
  const remainingMalls = mallList.length - 3
  let scheduleData = schedule ? schedule : ''

  if (participatingMalls) {
    scheduleData = scheduleData + (schedule ? ' | ' : '') + participatingMalls

    if (remainingMalls > 0) {
      scheduleData = scheduleData + ` +${remainingMalls} more malls`
    }
  }

  const articleBodyHtml = React.useMemo(
    () => wrapMarketingBodyTables(sanitizeHTML(body)),
    [body],
  )

  // ADS DISABLED

  // const [adType] = React.useState(Math.random() >= 0.5)
  // const [isRefRendered, setRefRendered] = React.useState(null)
  // const bodyRef = React.useRef(null)

  // React.useEffect(() => {
  // if (bodyRef.current) {
  //   let middleNode = Math.ceil(bodyRef.current.childNodes.length / 2 || 0)

  //   if (
  //     /H[1-7]/.test((bodyRef.current.childNodes[middleNode] || {}).nodeName)
  //   )
  //     middleNode -= 1

  //   const middleAdContainer = document.createElement('div')
  //   middleAdContainer.setAttribute('id', 'middle-ad')

  //   bodyRef.current.insertBefore(
  //     middleAdContainer,
  //     bodyRef.current.childNodes[middleNode],
  //   )

  // ReactDOM.render(
  //   <ResponsiveAdsContainer
  //     sideModal
  //     desktop={<DesktopLeaderboard id="div-ad-innity-91043/12-top" />}
  //     mobile={<MobileRectangle id="div-ad-innity-91046/12-top" />}
  //   />,
  //   document.getElementById('middle-ad'),
  // )

  // ReactDOM.render(
  //   <>
  //     {!adType ? (
  //       <ResponsiveAdsContainer
  //         sideModal
  //         desktop={<DesktopLeaderboard id="div-ad-innity-91043/12-top" />}
  //         mobile={<MobileRectangle id="div-ad-innity-91046/12-top" />}
  //       />
  //     ) : (
  //       <ResponsiveAdsContainer
  //         sideModal
  //         desktop={<InnerPageLeaderboard id="div-totalmedia-12a-top" />}
  //         mobile={<InnerPageRectangle id="div-totalmedia-12b-top" />}
  //       />
  //     )}
  //   </>,
  //   document.getElementById('middle-ad'),
  // )
  // }
  // }, [isRefRendered])

  return (
    <SideModal
      show={show}
      onClose={e => {
        e.stopPropagation()
        onClose()
      }}
      loading={loading}
    >
      <ReferenceWidth>
        <AspectRatioHelper>
          <StyledBanner background={bannerImageUrl} />
        </AspectRatioHelper>
      </ReferenceWidth>
      <Container>
        <ContentContainer>
          <Title>{title}</Title>
          <Schedule>{scheduleData}</Schedule>
          {/* <ResponsiveAdsContainer
            sideModal
            desktop={<DesktopLeaderboard id="div-ad-innity-91043/15-top" />}
            mobile={<MobileRectangle id="div-ad-innity-91046/15-top" />}
          /> */}
          {/* {adType ? (
            <ResponsiveAdsContainer
              sideModal
              desktop={<DesktopLeaderboard id="div-ad-innity-91043/15-top" />}
              mobile={<MobileRectangle id="div-ad-innity-91046/15-top" />}
            />
          ) : (
            <ResponsiveAdsContainer
              sideModal
              desktop={<InnerPageLeaderboard id="div-totalmedia-15a-top" />}
              mobile={<InnerPageRectangle id="div-totalmedia-15b-top" />}
            />
          )} */}
          <br />
          <Body
            dangerouslySetInnerHTML={{ __html: articleBodyHtml }}
            // ref={this.bodyRef}
          />
          {/*  <ResponsiveAdsContainer
            sideModal
            desktop={<DesktopLeaderboard id="div-ad-innity-91043/15-bottom" />}
            mobile={<MobileRectangle id="div-ad-innity-91046/15-bottom" />}
          /> */}
          {/* {adType ? (
            <ResponsiveAdsContainer
              sideModal
              desktop={
                <DesktopLeaderboard
                  id="div-ad-innity-91043/15-bottom"
                />
              }
              mobile={<MobileRectangle id="div-ad-innity-91046/15-bottom" />}
            />
          ) : (
            <ResponsiveAdsContainer
              sideModal
              desktop={<InnerPageLeaderboard id="div-totalmedia-15a-bottom" />}
              mobile={<InnerPageRectangle id="div-totalmedia-15b-bottom" />}
            />
          )} */}
          <Subtitle>Participating Malls</Subtitle>
          <MallList>
            {!!propMalls &&
              malls.length > 0 &&
              propMalls.map(mall => {
                return malls
                  .filter(eventMall => String(mall.id) === String(eventMall.id))
                  .map(eventMall => {
                    return (
                      <StyledLink
                        to={`/main/malls/${mall.slugName}`}
                        key={mall.id}
                      >
                        <MallLogo logo={mall.iconUrl} />
                      </StyledLink>
                    )
                  })
              })}
          </MallList>
          <ShareContainer>
            <ShareBaseButton
              small
              variant="primary"
              icon={<Icon name="share" />}
            >
              Share
            </ShareBaseButton>
            <ShareButtons>
              <FacebookShareButton url={shareUrl} quote={title}>
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <LinkedinShareButton url={shareUrl} quote={title}>
                <LinkedinIcon size={32} round />
              </LinkedinShareButton>
              <TwitterShareButton url={shareUrl} quote={title}>
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <TelegramShareButton url={shareUrl} quote={title}>
                <TelegramIcon size={32} round />
              </TelegramShareButton>
              <ViberShareButton url={shareUrl} quote={title}>
                <ViberIcon size={32} round />
              </ViberShareButton>
            </ShareButtons>
          </ShareContainer>
        </ContentContainer>
        {!!relatedArticles.length && (
          <RelatedContainer>
            <RelatedTitle>You Might Also Like:</RelatedTitle>
            {relatedArticles.map(item => (
              <ArticleCard
                key={`${item.type}-${item.itemId}`}
                title={item.title}
                imageUrl={item.imageUrl}
                logoUrl={item.logoUrl}
                schedule={item.schedule || item.subtitle}
                link={`${viewTypeBaseUrl(item.type)}/${item.slugName}`}
              />
            ))}
          </RelatedContainer>
        )}
      </Container>
    </SideModal>
  )
}

export default MarketingContentModal
